import { isNil } from 'lodash';
import { MouseEvent } from 'react';
import { MBAnalytics } from '@shared/util/analytics';
import { useBoolean } from '@shared/util/hooks';
import { ButtonBaseProps } from './ButtonProps';

type AsyncOnClickProps = Pick<ButtonBaseProps, 'onClick' | 'loading' | 'attributionId'>;

type AsyncOnClickReturn = [boolean, ButtonBaseProps['onClick']];

export function useOnClickAsync({
  onClick,
  loading = false,
  attributionId,
}: AsyncOnClickProps): AsyncOnClickReturn {
  const [isWaiting, startWaiting, stopWaiting] = useBoolean(false);

  async function onClickAsync(event: MouseEvent<HTMLButtonElement>) {
    if (!isNil(attributionId)) {
      MBAnalytics.track('ButtonPress', { attributionId });
    }

    // start waiting if onPress returns a promise
    const result = onClick?.(event);
    if (result instanceof Promise) {
      try {
        startWaiting();
        await result;
      } finally {
        stopWaiting();
      }
    }
  }

  return [isWaiting || loading, onClickAsync];
}
